import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCrawlSiteTest implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrawlSiteTestContainer";
    }
    render(){
        // console.log("Crawl Site Test");
    }
}
